<script>
	//Components
	import SelectInput from '@/Components/SelectInput.svelte';
	import { Countries, CountryNames } from '@/Constants/Country';

	export let label = '';
	export let name;
	export let value = '';
	export let className = '';
	export let errors = [];

	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, value, className, errors, ...rest }) => rest)($$props);
</script>

<SelectInput {...props} bind:value {className} {errors} {label} {name}>
	<option value="" selected disabled>Please select your country</option>
	<option value={Countries.AU}>{CountryNames[Countries.AU]}</option>
	<option value={Countries.NZ}>{CountryNames[Countries.NZ]}</option>
</SelectInput>
